// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "./default/chunk-article-listed.e4f5aaa357fcc9abe4f2.js";
	if (chunkId === 38) return "./default/chunk-subscription.b520bc0eaf1e3612506f.js";
	if (chunkId === 66) return "./66.cf0bce202ebef53caad9.js";
	if (chunkId === 36) return "./default/chunk-small-gallery.267d454f6767d757e8b6.js";
	if (chunkId === 32) return "./default/chunk-photo-credit-toogle.b0f2f56ea50ed62d7333.js";
	if (chunkId === 37) return "./default/chunk-social-click.c3de4537164193c57a24.js";
	if (chunkId === 40) return "./default/chunk-table.a67e40bc43b92aa4a8d9.js";
	if (chunkId === 44) return "./default/gallery-in-art-preserve-scroll.8b0c24598a11ed1e4016.js";
	if (chunkId === 67) return "./67.bdceca444c29a67f30aa.js";
	if (chunkId === 31) return "./default/chunk-online-reports.9e870f6f2d6b91e42433.js";
	if (chunkId === 6) return "./chunk-league-table.bfcf1f8d160e8b141130.js";
	// return url for filenames based on template
	return undefined;
};